import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Challenge } from '@app/model/challenge';
import { NavigateFrom } from '@app/model/enums/navigate-from.enum';
import { SlideDTO } from '@app/model/slideDTO.model';
import { ChallengeApiService } from '@app/services/api/challenge-api.service';
import { finalize, take } from 'rxjs';

@Component({
    selector: 'app-slide-challenges',
    templateUrl: './slide-challenges.component.html',
    styleUrls: ['./slide-challenges.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SlideChallengesComponent {
  @Input() public data: SlideDTO;

  constructor(
    private readonly router: Router,
    private readonly challengeApiService: ChallengeApiService) { }

  public joinChallenge(challenge: Challenge): void {
    if (challenge.isJoined) {
      this.continueChallenge(challenge);
      return;
    }

    this.challengeApiService.joinChallenge(challenge.id)
      .pipe(
        take(1)
      )
      .subscribe(() => {
        this.continueChallenge(challenge);
      });
  }

  public continueChallenge(challenge: Challenge): void {
    const nextQuiz = challenge.contents.find(quiz => !quiz.progress);

    if (!nextQuiz) {
      return;
    }

    this.router.navigate(['/chapters'], {
      queryParams: {
        lessonID: nextQuiz.id,
        from: NavigateFrom.CHALLENGE,
        fromId: challenge.id
      }
    });
  }

  public navigateToChallenge(challenge: Challenge): void {
    this.router.navigate(['/challenge', challenge.id]);
  }
}
